import React from "react";
import { Page } from "../../layouts/Page";
import { Toolbar, ToolbarGroup } from "../../molecules/Toolbar";
import { Button, Callout, Intent, Tooltip } from "@blueprintjs/core";
import classNames from "classnames";
import styles from "./Dashbaord.module.scss";
import { Spinner } from "@blueprintjs/core";
import Checklist from "../../molecules/Checklist/Checklist";
import DashboardIntroduction from "./DashboardDetails/DashboardIntroduction";
import Stats from "./DashboardDetails/Stats";
import InfluencerInfo from "./DashboardDetails/InfluencerInfo";
import useDashboardReport from "./hooks";
import moment from "moment";

function Dashboard() {
  const dashboardProps = useDashboardReport();
  const {
    loading,
    error,
    influencerReport,
    accountType,
    subscription,
    hasSales,
    showChecklist,
    welcomeMessage,
    isNmiAccount
  } = dashboardProps;

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return (
      <Page title="Dashboard">
        <Callout
          intent={Intent.DANGER}
          title="Something went wrong!"
          style={{ marginBottom: "1em" }}
          icon="error"
        >
          Try again or contact support if the problem persists.
        </Callout>
      </Page>
    );
  }

  return (
    <Page title="Dashboard">
      <Toolbar title="Account Overview">
        <ToolbarGroup>
          <Tooltip
            popoverClassName={styles.packageInfoTooltip}
            content={`Next Billing : ${
              subscription
                ? moment(subscription.currentPeriodEnd).format("DD-MMM-YYYY")
                : ""
            }`}
            position={"bottom"}
          >
            <Button className={styles.btnPackageInfo} intent={Intent.PRIMARY}>
              {accountType}
            </Button>
          </Tooltip>
        </ToolbarGroup>
      </Toolbar>

      <div className={styles.dashboardLayout}>
        <div className={styles.row}>
          <div className={styles.col}>
            <h3 className={styles.heading}>Welcome To Video Squirrel</h3>
            <div className={styles.desc}>
              <span>
                {welcomeMessage[accountType] ||
                  "This message will be replaced with the message for user type Ecommerce"}
              </span>
            </div>
            {showChecklist ? (
              <Checklist
                accountType={accountType}
                isNmiAccount={isNmiAccount}
              />
            ) : (
              <Stats {...dashboardProps} />
            )}
          </div>

          <div
            className={
              showChecklist
                ? classNames(styles.colHalf, styles.borderLeft)
                : classNames(styles.colOne, styles.borderLeft)
            }
          >
            {showChecklist ? (
              <DashboardIntroduction />
            ) : (
              <InfluencerInfo
                influencerReport={influencerReport}
                accountType={accountType}
                hasSales={hasSales}
              />
            )}
          </div>
        </div>
      </div>
    </Page>
  );
}

export default Dashboard;
